import { createApp, type Directive } from 'vue'
import Study from '@/Study.vue'
import { router } from '@/router'
import { userModule } from '@/store/user/module'
import { analyticsModule } from '@/store/analytics/module'
import '@pocketprep/ui-kit/normalize'
import '@pocketprep/ui-kit/fonts'
import '@pocketprep/ui-kit/styles'
import './study.scss'
import * as Sentry from '@sentry/vue'
import { SentryInit } from '@/sentry'

const app = createApp(Study)

analyticsModule.actions.initAmplitude()
SentryInit(app)

app.use(router)

import PortalVue from 'portal-vue'
app.use(PortalVue)

import Vue3Lottie from 'vue3-lottie'
app.use(Vue3Lottie, { name: 'LottieAnimation' })

// prevent error from Vite when it fails to load dynamic imports, then reload
window.addEventListener('vite:preloadError', (event) => {
    if (event.payload.message.includes('Importing a module script failed.')) {
        event.preventDefault()
    }
    window.location.reload()
})

app.config.errorHandler = (e) => {
    const error = e as Error | string
    if (error.toString().includes('Invalid session token')) {
        userModule.actions.signOut().then(() => {
            router.push({
                name: 'sign-in',
                query: {
                    error: 'Your session has expired. Please sign in again to continue studying.',
                },
            }).catch(() => {
                // noop
            })
        })
    } else if (error instanceof Error) {
        Sentry.captureException(error)
        throw error
    } else {
        const newError = new Error(error)
        Sentry.captureException(newError)
        throw newError
    }
}
export const dark: Directive<HTMLElement> = (el, { value }: { value?: boolean }) => {
    const isDarkMode = value === undefined
        ? userModule.state.settings.isDarkMode
        : value
    const classes = (typeof el.className === 'string'
        ? el.className
        : (el.className as unknown as { baseVal: string }).baseVal).split(' ')
    if (isDarkMode) {
        if (classes.find(c => c.endsWith('--dark'))) {
            return
        }
        classes.forEach(className => {
            el.classList.add(`${className}--dark`)
        })
    } else {
        classes.forEach(className => {
            if (className.includes('--dark')) {
                el.classList.remove(className)
            }
        })
    }
}
app.directive('dark', dark)

app.mount('#study')
